export enum LocaleCode {
  English = `en`,
  French = `fr`,
  Spanish = `es`,
  Portuguese = `pt`,
  Korean = `ko`,
  Japanese = `ja`,
  TraditionalChinese = `zh-TW`,
  SimpliedChinese = `zh-CN`,
  Indonesian = `id`,
}

export type Locale = {
  code: LocaleCode;
  displayName: string;
  englishName: string;
};

/** A list of supported languages. */
export const LOCALES: Locale[] = [
  {
    code: LocaleCode.English,
    displayName: `English`,
    englishName: `English`,
  },
  {
    code: LocaleCode.French,
    displayName: `Français`,
    englishName: `French`,
  },
  {
    code: LocaleCode.Spanish,
    displayName: `Español`,
    englishName: `Spanish`,
  },
  {
    code: LocaleCode.Portuguese,
    displayName: `Português`,
    englishName: `Portuguese`,
  },
  {
    code: LocaleCode.Korean,
    displayName: `한국어`,
    englishName: `Korean`,
  },
  {
    code: LocaleCode.Japanese,
    displayName: `日本語`,
    englishName: `Japanese`,
  },
  {
    code: LocaleCode.TraditionalChinese,
    displayName: `繁體中文`,
    englishName: `Traditional Chinese`,
  },
  {
    code: LocaleCode.SimpliedChinese,
    displayName: `简体中文`,
    englishName: `Simplified Chinese`,
  },
  {
    code: LocaleCode.Indonesian,
    displayName: `Bahasa Indonesia`,
    englishName: `Indonesian`,
  },
];

export const LOCALE_MAP = new Map<LocaleCode, Locale>(LOCALES.map((locale) => [locale.code, locale]));

export type ForeignLocaleCode = Exclude<LocaleCode, LocaleCode.English>;
type ForeignLocale = Omit<Locale, `code`> & {
  code: ForeignLocaleCode;
};
export const FOREIGN_LOCALES: ForeignLocale[] = LOCALES.filter(
  (locale): locale is ForeignLocale => locale.code !== LocaleCode.English,
);
